export const APP_STATUS = {
  nova_solicitacao: { label: "Nova Solicitação", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  em_analise: { label: "Em Análise", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  aguardando_informacoes: { label: "Aguardando Informações", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  aprovada: { label: "Aprovada", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  recusada: { label: "Recusada", cls: "bg-red-50 text-red-700 border-red-200" },
  aguardando: { label: "Aguardando análise", cls: "bg-blue-50 text-blue-700 border-blue-200" },
  pendencias: { label: "Pendências", cls: "bg-orange-50 text-orange-800 border-orange-200" },
  aguardando_documentos: { label: "Aguardando Documentos", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  contrato_pendente: { label: "Contrato Pendente", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  contrato_assinado: { label: "Contrato Assinado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  emprestimo_ativo: { label: "Empréstimo Ativo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  finalizado: { label: "Finalizado", cls: "bg-slate-100 text-slate-700 border-slate-200" },
};

export const INST_STATUS = {
  pendente: { label: "Pendente", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  pago: { label: "Pago", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  vencido: { label: "Vencido", cls: "bg-red-50 text-red-700 border-red-200" },
  parcial: { label: "Parcial", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  renegociado: { label: "Renegociado", cls: "bg-violet-50 text-violet-700 border-violet-200" },
};

export const DOC_STATUS = {
  pendente: { label: "Pendente", cls: "bg-slate-100 text-slate-700 border-slate-200" },
  em_analise: { label: "Em Análise", cls: "bg-amber-50 text-amber-700 border-amber-200" },
  aprovado: { label: "Aprovado", cls: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  recusado: { label: "Recusado", cls: "bg-red-50 text-red-700 border-red-200" },
};

export const APP_STATUS_FLOW = [
  "nova_solicitacao", "em_analise", "aguardando_informacoes", "aprovada", "recusada",
];

export const FREQ = {
  diaria: "Diária — Segunda a sábado", diaria_full: "Diária — Full (todos os dias)", semanal: "Semanal", quinzenal: "Quinzenal", mensal: "Mensal", dias_semana: "Dias da semana (escolher)",
};

// Catálogo único (espelha backend/doc_catalogo.py): mesmos nomes em formulário externo, cadastro, Documentos, CRM e Portal
export const DOC_TYPES = [
  "RG ou CNH (frente)", "RG ou CNH (verso)", "Selfie segurando documento",
  "Comprovante de residência", "Foto da frente da casa", "Vídeo do cliente", "Comprovante comercial", "Foto do comércio", "Foto do carro",
  "CNH digital (PDF)", "CNH (foto frente)", "CNH (foto verso)", "CRLV digital (PDF)", "Documento do veículo (foto)", "Outros documentos",
];
// Modalidade por tipo: "digital" aceita somente PDF; "foto" somente imagem; vazio = ambos
export const DOC_MODALIDADE = { "CNH digital (PDF)": "digital", "CRLV digital (PDF)": "digital", "CNH (foto frente)": "foto", "CNH (foto verso)": "foto", "Documento do veículo (foto)": "foto",
  "RG ou CNH (frente)": "foto", "RG ou CNH (verso)": "foto", "Selfie segurando documento": "foto", "Foto da frente da casa": "foto", "Foto do comércio": "foto", "Foto do carro": "foto" };
